import { render, staticRenderFns } from "./BasePhoneInput.vue?vue&type=template&id=a51f9550&scoped=true&lang=pug&"
import script from "./BasePhoneInput.vue?vue&type=script&lang=js&"
export * from "./BasePhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./BasePhoneInput.vue?vue&type=style&index=0&id=a51f9550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51f9550",
  null
  
)

export default component.exports